export const styles = theme => ({
  dateRow: {
    height: 28,
  },
  highlighted: {
    backgroundColor: theme.palette.action.hover
  },
  tableCell: {
    paddingLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit
  },
  carrierSelect: {
    fontSize: '0.8125rem'
  },
  sourceField: {
    width: 15,
  },
  sourceInput: {
    padding: 0,
    fontSize: '0.8125rem'
  },
  full: {
    color: 'red'
  },
  disabled: {
    opacity: 0.3,
    pointerEvents: 'none'
  }
})


// WEBPACK FOOTER //
// ./src/components/BigCalendar/components/BigCalendarBody/styles.js